const nb = {
  "lines": [
    "Psst! Har du funnet meg ennå?",
    "Bø! Bare sjekker hvordan det går.",
    "Ikke si til noen at jeg er her …",
    "Jeg lukter vafler et sted …",
    "Har du sett fossen min?",
    "Hysj … jeg gjemmer meg for trolljegerne!",
    "Bare scroll videre — jeg ser deg!",
    "Er det 1. februar ennå?"
  ],
  "giant": [
    "HALLO DER NEDE!",
    "Hvem er det som scroller på brua mi?",
    "Jeg er ikke stor. Du er liten."
  ],
  "golden": "Du fikk øye på gulltrollet! Bare noen få heldige ser meg.",
  "goldenTag": "Legendarisk"
};

export default nb;
